export const SET_VIDEO_COMPATIBILITY_MODE = 'SET_VIDEO_COMPATIBILITY_MODE';

export function setVideoCompatibilityMode(videoCompatibilityMode) {
    return {
        type: SET_VIDEO_COMPATIBILITY_MODE,
        payload: videoCompatibilityMode,
        persistent: true,
    };
}
